import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DCRoadReelsView} from "../../reels/DCRoadReelsView";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";


export class DCRoadNormalResultPresentation implements FlowStatePresentation {

    private _nearWinStopDelay:number = 2;
    private _defaultSpinDuration:number;

    constructor() {}

    start(flowStateController:FlowStateController):void {
        if(DevilsCrossRoad.model.buyFeatureName === "LUCKY_DRAW" && DevilsCrossRoad.model.data.mode === DevilsCrossRoadGameMode.NORMAL && DevilsCrossRoad.model.data.nextMode.includes(DevilsCrossRoadGameMode.FREESPIN)) {
            DevilsCrossRoad.scatters.startLuckDrawNearWin();
            DevilsCrossRoad.reels.reelView.stopOrder = DCRoadReelsView.STOP_ORDER_WAVE_COUNTER.concat();
        } else {
            DevilsCrossRoad.reels.reelView.stopOrder = DCRoadReelsView.STOP_ORDER_QUAD_COUNTER.concat();
        }

        flowStateController.setSkipCallback(() => this.skip());
        DevilsCrossRoad.reelStopPresentations.start().then(res => {
            DevilsCrossRoad.backgroundElements.setMainFrame("glow_static", false);
            flowStateController.finish();
        });

        if(!this._defaultSpinDuration) {
            // This simple calculation doesn't cover strange stopping order.
            this._defaultSpinDuration = DCRoadReelsView.STOP_ORDER_QUAD_COUNTER.reduce((a, b) => { return a + b[4]; }, 0);
        }

        let delay = DevilsCrossRoad.scatters.isNearWin ? this._nearWinStopDelay : 0;
        // The spin time should not leak there is feature later, like a near win. so I use a default spin time here to calculation Jurisdiction padding.
        // fastSpin is off when there is spin time limit, so we don't need to consider it here. To change if something changed.
        const padding = DevilsCrossRoad.gameFlowController.calculatePaddingDuration(this._defaultSpinDuration);
        if(padding > 0) {
            // Logger.logDev("Added minimum jurisdiction padding  ", padding);
            DevilsCrossRoad.reels.reelView.stopQuadPadding = padding * 0.25;
        }

        this.getReelsStopResult(false, delay);
    }

    private skip():void {
        Logger.logDev("skip result");
        DevilsCrossRoad.reelStopPresentations.skip();
        this.getReelsStopResult(true, 0);
    }

    private getReelsStopResult(quickStop:boolean, delay:number):void {
        DevilsCrossRoad.reels.tryStop(quickStop, delay);
    }
}